import React, { useEffect } from "react";
import { string, object, func } from "prop-types";
import { connect } from "react-redux";
import assetify from "@quintype/framework/assetify";
import get from "lodash/get";

// TODO: Get sister company dynamically based on config
import { Button } from "../../basic/button";
import ProfileImage from "../../atoms/profile-image";

import NHlogo from "../../basic/images/nh.svg";
import NJlogo from "../../basic/images/nav.svg";
import QAlogo from "../../basic/images/qaumi.svg";

import { getUser } from "../../utils/api";
import { setMember, setUserPlans } from "../../helper/actions";
import { setAccessTypeUser, getUserSubscriptions } from "../../helper/access-type";

import "./styles.m.css";

function SisterCompaniesBase({
  className = "",
  publisherAttributes = {},
  onHamburgerToggle,
  navigateToPage,
  onLoginClick,
  member,
  setMember,
  setUserPlans
}) {
  useEffect(() => {
    getUser()
      .then(result => {
        // result.user["phone-number"] = null;  // only for testing purpose
        setMember(result.user);

        const { user } = result;

        setAccessTypeUser(user.email, user["phone-number"], user.id, user.name).then(() => {
          getUserSubscriptions().then(data => setUserPlans(data.subscriptions));
        });
      })
      .catch(ex => ex.message);
  }, []);

  const profileClick = () => {
    onHamburgerToggle && onHamburgerToggle();
    navigateToPage("/profile");
  };

  const contributeClick = () => {
    onHamburgerToggle && onHamburgerToggle();
    navigateToPage("/contribute");
  };

  // Show the Login or Settings View depending whether user is logged in
  const loginView = () => {
    if (member) {
      return (
        <a onClick={profileClick}>
          <ProfileImage member={member} />
        </a>
      );
    }

    return (
      <Button onClick={onLoginClick} className="btn-login">
        Login
      </Button>
    );
  };

  return (
    <div className={className}>
      <div
        styleName={`sister-companies ${publisherAttributes.lang === "hi" ? "sister-company-nj" : ""} ${
          publisherAttributes.lang === "ur" ? "sister-company-qa" : ""
        } ${publisherAttributes.lang === "en" ? "sister-company-nh" : ""}`}
      >
        {publisherAttributes.lang !== "hi" ? (
          <a href="https://www.navjivanindia.com/" rel="noopener noreferrer" target="_blank">
            <img className="nj-logo" src={`${assetify(NJlogo)}`} alt="logo" width="90" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "ur" ? (
          <a href="https://www.qaumiawaz.com/" rel="noopener noreferrer" target="_blank">
            <img className="ur-logo" src={`${assetify(QAlogo)}`} alt="logo" width="120" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "en" ? (
          <a href="https://www.nationalheraldindia.com/" rel="noopener noreferrer" target="_blank">
            <img className="nh-logo" src={`${assetify(NHlogo)}`} alt="logo" width="140" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "ur" ? (
          <Button className="epaper-btn">
            <a
              href={publisherAttributes["epaper_link"] ? publisherAttributes["epaper_link"] : "javascript:void(0)"}
              rel="noopener noreferrer"
              target="_blank"
            >
              E paper
            </a>
          </Button>
        ) : null}

        <React.Fragment>
          <Button className="subscriptions-btn">
            <a onClick={contributeClick}>Contribute</a>
          </Button>

          {loginView()}
        </React.Fragment>
      </div>
    </div>
  );
}

SisterCompaniesBase.propTypes = {
  className: string,
  publisherAttributes: object,
  member: object,
  setMember: func,
  setUserPlans: func,
  onHamburgerToggle: func,
  navigateToPage: func,
  onLoginClick: func
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"]),
    member: state.member
  };
}

const mapDispatchToProps = dispatch => ({
  setMember: member => dispatch(setMember(member)),
  setUserPlans: list => dispatch(setUserPlans(list)),
  navigateToPage: url => global.app.navigateToPage(dispatch, url)
});

export const SisterCompanies = connect(
  mapStateToProps,
  mapDispatchToProps
)(SisterCompaniesBase);
